if (!customElements.get("lang-switcher")) {
  customElements.define(
    "lang-switcher",
    class LangSwitcher extends HTMLElement {
      constructor() {
        super();

        this.lang = "fr";
        this.cookie = "";
        this.addEventListener("click", this.onLangSwitch.bind(this));
      }

      connectedCallback() {
        console.log("THIS", this);

        this.cookie = this.getCookie("ziggy_lang");
        console.log("Cookie", this.cookie);
      }

      onLangSwitch(evt) {
        if (!evt.target.dataset.lang) return;

        this.lang = evt.target.dataset.lang;
        console.log("LANG", evt.target.dataset.lang);

        document.cookie = `ziggy_lang=${evt.target.dataset.lang}; path=/;`;

        let url =
          "http://127.0.0.1:9292/products/patee-naturelle-sans-cereale-chat-sterilise-poulet?variant=47582516445523";
        if (this.lang === "en")
          url =
            "http://127.0.0.1:9292/en/products/patee-naturelle-sans-cereale-chat-sterilise-poulet?variant=47582516445523";

        window.location.href = url;

        /*fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const newHtml = new DOMParser()
              .parseFromString(responseText, "text/html")
              .querySelector("#productSheet").innerHTML;

            document.querySelector("#productSheet").innerHTML = newHtml;
          });
          */
      }

      onProductSwitch(evt) {
        if (!evt.target.dataset.switchUrl) return;
        this.productUrl = evt.target.dataset.switchUrl;
        this.switchId = evt.target.dataset.switchId;
        let url = `${this.productUrl}?section_id=${this.sectionId}`;

        //let url = `${this.productUrl}?section_id=template--25124498342202__product_recommendations_gnGhaz`;

        this.updateURL(this.productUrl);

        if (document.querySelector("product-recommendations")) {
          const dynamicSections = document.querySelectorAll(
            "product-recommendations"
          );
          //const section = dynamicSections[0]
          //section.dataset.productId = this.switchId
          //section.dataset.recommendationsPerformed = "false"

          dynamicSections.forEach(async (section) => {
            console.log("Must update this section: ", section.dataset);
            section.dataset.productId = this.switchId;
            section.dataset.recommendationsPerformed = "false";
          });
        }

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const newHtml = new DOMParser()
              .parseFromString(responseText, "text/html")
              .querySelector("#productSheet").innerHTML;

            document.querySelector("#productSheet").innerHTML = newHtml;
          });
      }

      updateURL(url) {
        window.history.replaceState({}, "", `${url}`);
      }

      getCookie(name) {
        const match = document.cookie.match(
          new RegExp("(^| )" + name + "=([^;]+)")
        );
        if (match) {
          return match[2];
        }
        return null;
      }
    }
  );
}

if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]'
          ),
          button: this.querySelector("button"),
          panel: this.querySelector(".disclosure__list-wrapper"),
        };
        this.elements.button.addEventListener(
          "click",
          this.openSelector.bind(this)
        );
        this.elements.button.addEventListener(
          "focusout",
          this.closeSelector.bind(this)
        );
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

        this.querySelectorAll("a").forEach((item) =>
          item.addEventListener("click", this.onItemClick.bind(this))
        );
      }

      hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        if (this.elements.button.getAttribute("aria-expanded") == "false")
          return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        console.log("this.elements.input.value", this.elements.input.value);
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (
            this.elements.button.getAttribute("aria-expanded") === "false"
          ).toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) ||
          this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}

/*
  let lang = {{ request.locale.iso_code }};

  console.log('LANG', lang)

  if (lang !== 'fr') {
    let inputs = document.querySelectorAll('variant-selects input[data-lang="en"]');
    console.log('inputs', inputs[0])
    inputs[0].checked = true;
    const selectedVariantJson = document.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
    console.log('selectedVariantJson', JSON.parse(selectedVariantJson));
    let url = {{ product.url | json }};
    let variantId =  inputs[0]?.dataset?.variantId;
    window.history.replaceState({},"",`${url}${variantId ? `?variant=${variantId}` : ""}`);
  }


/*
  <script>
const YOUR_DOMAIN = window.location.origin
const YOUR_DOMAIN_LENGTH = YOUR_DOMAIN.length
const SUPPORTED_LANGUAGES = ["fr"]
const LANGUAGE_COOKIE_NAME = "language"
const BROWSER_LANGUAGE = navigator.language
function getCookie(name) {
const value = `; ${document.cookie}`;
const parts = value.split(`; ${name}=`);
if (parts.length === 2) return parts.pop().split(';').shift();
}

function setDefaultLanguage(){
let selectedLanguage = getCookie(LANGUAGE_COOKIE_NAME)
if (!selectedLanguage) {
console.log("No selected lang")
for (const lang of SUPPORTED_LANGUAGES){
console.log("Lang", lang)
if(BROWSER_LANGUAGE.includes(lang)){
document.cookie = `${LANGUAGE_COOKIE_NAME}=${lang};`;
if (!window.location.href.includes(`${YOUR_DOMAIN}/${lang}`)){
var url = window.location.href;
var redirect_url = url.slice(0, YOUR_DOMAIN_LENGTH) + `/${lang}` + url.slice(YOUR_DOMAIN_LENGTH);
console.log(url.slice(0, YOUR_DOMAIN_LENGTH))
window.location.href= redirect_url;
}
break;
}
}
}
}
setDefaultLanguage()
</script>
*/
